<div
    class="tab-header-width"
    [class.is-right]="isRight()"
    webTabHeaderWidth
    [widthValue]="widthValue()"
    [widthUnit]="widthUnit()"
    [rootElementId]="rootElementId()"
    [headerElementId]="headerElementId()"
    [bodyElementId]="bodyElementId()"
    [isRight]="isRight()"
    (widthChange)="widthChange.emit($event)"
    (dragStart)="dragStart.emit()"
    (dragEnd)="dragEnd.emit()"
>
    <button class="tab-header-width-btn">
        <img src="./assets/img/websites/lpc-resize-column-icon.svg" alt="resize" />
    </button>
</div>
